import axios from 'axios';

const BASE_PATH = '/api/v1/accounts';

export default {
  show(accountId) {
    return axios.get(`${BASE_PATH}/${accountId}/storage_quota`);
  },

  update(accountId, data) {
    return axios.patch(`${BASE_PATH}/${accountId}/storage_quota`, data);
  },
};
